'use strict'

import store from '@/store'
import { merge } from 'lodash-es'

const actions = {
  /** 選擇帖子列表 **/
  updateThreadSelectedStatus ({ commit }, options) {
    let checkBox = { tid: options.tid }
    commit('setLastSelectThread', checkBox.tid)
  },
  /** 顯示管理操作工具 */
  setThreadTools ({ commit }, options) {
    commit('setThreadTools', options)
  }
}

export default actions
